import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`⚠️⚠️ Important remarks before you start ⚠️⚠️`}</h2>
    <p>{`Those are remarks regarding feedback and problem reports I got from the field.`}</p>
    <p>{`Those scripts have been tested thoroughly on different environments and have proven to be VERY reliable.`}</p>
    <p>{`If you think that you hit a problem:`}</p>
    <ul>
      <li parentName="ul">{`Make sure that you have provisioned a cluster with `}<strong parentName="li">{`5 worker nodes with 32 CPU and 128 GB`}</strong>{` each (`}<inlineCode parentName="li">{`b3c.16x64`}</inlineCode>{` - it’s easy to select the wrong size). If you have Pods in `}<inlineCode parentName="li">{`0/0`}</inlineCode>{` state verify the `}<inlineCode parentName="li">{`Events`}</inlineCode>{`. If you get `}<inlineCode parentName="li">{`Not enough CPU`}</inlineCode>{` then delete the cluster and provision the correct size.`}</li>
      <li parentName="ul">{`If you want to install AIManager, Event Manager, Trubonomic and Instana please select `}<strong parentName="li">{`5 worker nodes with 32 CPU and 128 GB`}</strong></li>
      <li parentName="ul">{`The complete installation takes about 2.5 to 8 hours depending on your region where and how you deployed ROKS to (see above).`}</li>
      <li parentName="ul">{`If you see Pods in `}<inlineCode parentName="li">{`CrashLoop`}</inlineCode>{` or other error states, try to wait it out (this can be due to dependencies on other componenets that are not ready yet). Chances are that the deployment will eventually go through. If after 8h you are still stuck, ping me.`}</li>
    </ul>
    <InlineNotification kind="error" mdxType="InlineNotification">
      <p>{`Important`}</p>
      <p><strong parentName="p">{`Simply put:`}</strong></p>
      <p>{`❗ Be patient and make sure you have the correct size of cluster provisioned!`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      